import { render, staticRenderFns } from "./submitService.vue?vue&type=template&id=320ec414&"
import script from "./submitService.vue?vue&type=script&lang=js&"
export * from "./submitService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports